import { struct, u8 } from "@project-serum/borsh";
import { blob } from "buffer-layout";

// https://github.com/solana-labs/solana-program-library/blob/master/token/js/client/token.js#L210

export const dataLayout = struct([u8("instruction"), blob(8, "amount")]);
